import { TOGGLE_NARRATOR } from "../types";

export const toggleNarratorAction = () => (dispatch) => {
  dispatch({ type: TOGGLE_NARRATOR });
};
